<div *ngIf="isProcessing">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<div class="content-header">
  <div class="container-fluid">
  <div class="row mb-2">
      <div class="col-sm-6">
          <h3>Add Number Plate Payment</h3>
      </div>
      <div class="col-sm-6">
      <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a routerLink="/" ><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
          <li class="breadcrumb-item"><a routerLink="/vehicles/pending-number-plate-payment" ><i class="fa fa-list-ul"></i>&nbsp;Vehicles Pending Number Plate Payment</a></li>
          <li class="breadcrumb-item active">Add Number Plate Payment</li>
      </ol>
      </div><!-- /.col -->
  </div><!-- /.row -->
  </div><!-- /.container-fluid -->
</div>
<!-- /.content-header -->
<div class="card">
  <div class="card-header">
      <h3 class="card-title">Add Number Plate Payment</h3>
       <!--Error message-->
       <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        <span [innerHTML]="errorMessage"></span>
      </div>
  </div>
<!-- /.card-header -->
  <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="handleSubmit()">
          <div class="row clearfix">
              <div class="col-md-4">
                  <div class="form-group">
                      <label>Make/Model:</label>
                      <input type="text" name="make" class="form-control" readonly placeholder="Make" value="{{vehicle.data.make}} {{vehicle.data.model}}">
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="form-group">
                      <label>Chassis No.:</label>
                      <input type="text" name="chassis_no" class="form-control" readonly placeholder="Chassis No" value="{{vehicle.data.chassis_no}}">
                  </div>
              </div>
          </div>
          <div class="row clearfix">
              <div class="col-md-4">
                  <div class="form-group">
                      <label>Invoice No.:<span style="color:red;">*</span></label>
                      <input type="text" formControlName="invoice_no" class="form-control" placeholder="Invoice Number" value="">

                      <span *ngIf="submitted && form.get('invoice_no')?.hasError('required')" style="color:red"> <strong>Please enter Invoice Number!</strong></span>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="form-group">
                      <label>Currency:<span style="color:red;">*</span></label>
                      <select formControlName="src_currency" class="form-control">
                        <option value="">Select</option>
                        <option value="KES">KES</option>
                        <option value="USD">USD</option>
                      </select>

                      <span *ngIf="submitted && form.get('src_currency')?.hasError('required')" style="color:red"> <strong>Please select currency!</strong></span>
                  </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                    <label>Amount:<span style="color:red;">*</span></label>
                    <input type="text" formControlName="amount" class="form-control" placeholder="Amount" value="">

                    <span *ngIf="submitted && form.get('amount')?.hasError('required')" style="color:red"> <strong>Please enter amount!</strong></span>
                </div>
              </div>
          </div>
          <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Save</button>
      </form>
  </div>
<!-- /.card-body -->
</div>
